<template>
  <base-layout>
    <v-row class="justify-space-between">
      <v-col md="3" cols="0">
      </v-col>
      <v-col class="row" md="9" cols="12">
        <v-col md="7" cols="12">
          <v-text-field v-model="searchText" dense label="Search" @keydown.enter="searchItem"/>
        </v-col>
        <v-col md="2" class="d-flex justify-center" cols="6">
          <v-btn outlined small color="primary" @click="searchItem()">
            Find
          </v-btn>
        </v-col>
        <v-col md="3" class="d-flex justify-center" cols="6">
          <v-btn outlined small color="green" @click="exportCsv()">
            Export ({{selectedRows.length }})
          </v-btn>
        </v-col>
      </v-col>
    </v-row>
    <paginate
      :page="parseInt(page)"
      :per-page="perPage"
      :total="total"
      @on-page-change="changePage" />
    <v-data-table
      :headers="headers"
      :items-per-page="25"
      :items="mapedData"
      :loading="loading"
      :options.sync="options"
      :server-items-length="25"
      @update:sort-by="optionsUpdated()"
      @update:sort-desc="optionsUpdated()"
      v-model="selectedRows"
      show-select
      hide-default-footer
      class="elevation-1">
      <template v-slot:[`item.tags`]="{ item, index }">
        <v-chip
          v-for="(tag, i) in item.tags"
          :key="`${index}-${i}`"
          class="mx-1"
          :color="getColor(tag)"
          x-small
          label
        >
          {{ tag }}
        </v-chip>

      </template>
      <template v-slot:[`item.option`]="{ item }">
        <v-menu>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on">
              mdi-dots-vertical
            </v-icon>
          </template>
          <v-list>
            <v-list-item @click="$router.push({ name: 'DealerDetail', params: { id: item.id }})">
              <v-list-item-title>Detail</v-list-item-title>
            </v-list-item>
            <v-list-item @click="$router.push({ name: 'UpdateDealer', params: { id: item.id }})">
              <v-list-item-title>Edit</v-list-item-title>
            </v-list-item>
            <v-list-item @click="print(item.id)">
              <v-list-item-title>Print</v-list-item-title>
            </v-list-item>
            <v-list-item @click="printForm(item.id)">
              <v-list-item-title>Print Form</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
  </v-data-table>
  </base-layout>
</template>

<script>
import DealerProvider from '@/resources/DealerProvider'
import dayjs from 'dayjs'
import { mapActions } from 'vuex'
import { ExportToCsv } from 'export-to-csv'

const dealerService = new DealerProvider()
export default {
  data: () => ({
    searchText: '',
    options: {
      sortBy: ['createdAt'],
      sortDesc: [true]
    },
    selectedRows: [],
    sortBy: 'createdAt',
    sortOrder: 'desc',
    loading: false,
    perPage: 25,
    total: 25,
    page: 1,
    data: [],
    headers: [
      { text: 'Name', value: 'firstName', sortable: true },
      { text: 'E-mail', value: 'email', sortable: true },
      { text: 'Facebook', value: 'facebook', sortable: true },
      { text: 'Tel', value: 'tel' },
      { text: 'Create Date', value: 'createdAt' },
      { text: 'Tags', value: 'tags' },
      { text: 'Option',  align: 'center', value: 'option' }
    ]
  }),
  computed: {
    mapedData () {
      return this.data.map(d => ({
        id: d.id,
        firstName: `${d.firstName} ${d.lastName}`,
        email: d.email,
        tel: d.tel,
        tags: d.tags,
        facebook: d.facebook,
        createdAt: dayjs(d.createdAt).format('DD-MM-YYYY HH:mm'),
        data: d
      }))
    },
    queryPage () {
      return this.$route.query.page ? this.$route.query.page : '1'
    },
    querySearch () {
      return this.$route.query.search ? this.$route.query.search : ''
    },
    querySortBy () {
      return this.$route.query.sort_by ? this.$route.query.sort_by : 'createdAt'
    },
    querySortOrder () {
      return this.$route.query.sort_order ? this.$route.query.sort_order : 'desc'
    }
  },
  created () {
    if (!this.$route.query.page || !this.$route.query.search || !this.$route.query.sort_by || !this.$route.query.sort_order) {
      this.$router.replace({
        name: 'DealerList',
        query: {
          page: this.$route.query.page ? this.$route.query.page : '1',
          search: this.$route.query.search ? this.$route.query.search : '',
          sort_by: this.$route.query.sort_by ? this.$route.query.sort_by : 'createdAt',
          sort_order: this.$route.query.sort_order ? this.$route.query.sort_order : 'desc'
        }
      }, () => {})
    }
    this.page = this.queryPage
    this.searchText = this.querySearch
    this.options.sortBy = [this.querySortBy]
    this.options.sortDesc = [(this.querySortOrder === 'desc')]
    this.getData()
  },
  methods: {
    ...mapActions({
      setSnackbar: 'Style/setSnackbar'
    }),
    getColor (tag) {
      const colors = ['pink', 'cyan', 'purple darken-2', 'red',
        'teal', 'teal accent-2', 'lime', 'orange', 'amber',
        'yellow', 'deep-orange', 'light-green accent-4', 'red darken-4', 'purple accent-1', 'blue',
        'indigo', 'teal', 'cyan', 'brown', 'blue-grey', 'brown darken-4', 'amber accent-2', 'yellow accent-4'
      ]
      return colors[tag.length % colors.length]
    },
    optionsUpdated () {
      if (this.options.sortBy[0]) {
        this.$router.push({
          name: 'DealerList',
          query: {
            page: this.queryPage,
            search: this.querySearch,
            sort_by: this.options.sortBy[0],
            sort_order: this.options.sortDesc[0] ? 'desc' : 'asc'
          }
        }, () => {})
      }
      this.getData()
    },
    displayTel (text) {
      return `+66${text.substr(1, text.length)}`
    },
    exportCsv () {
      const options = { 
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true, 
        showTitle: false,
        title: 'Dealer',
        filename: 'Dealer',
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: true
      }
      const csvExporter = new ExportToCsv(options)
      const payload = this.selectedRows.map(col => ({
        'ชื่อ - นามสกุล': `${col.data.firstName} ${col.data.lastName}`,
        'ชื่อเล่น': col.data.nickName,
        'อายุ': this.displayAge(col.data.dob),
        'ปีเกิด': dayjs(col.data.dob).format('YYYY'),
        'เดือนเกิด': dayjs(col.data.dob).format('MM'),
        'วันที่เกิด': dayjs(col.data.dob).format('DD'),
        'Email': col.data.email,
        'เพศ': col.data.gender,
        'รหัสตัวแทนเดิม': col.data.oldDealerId,
        'รหัสตัวแทนแม่ทีม': col.data.teamParentId,
        'สายทีม': col.data.classTeam,
        'รหัสสายทีม': col.data.classTeamId,
        'สถานะ': col.data.sellerStatus,
        'ที่อยู่ที่สามารถติดต่อได้สะดวก': col.data.address,
        'จังหวัด': col.data.province,
        'รหัสไปรษณีย์': col.data.postCode,
        'เบอร์โทรศัพท์': this.displayTel(col.data.tel),
        'LINE ID': col.data.lineId,
        'Instagram': col.data.instagram,
        'Facebook': col.data.facebook,
        'Facebook Fanpage': col.data.facebookPage,
        'พื้นที่ขาย': col.data.sellArea,
        'วันที่ยอมรับข้อตกลง': this.localDate(col.data.acceptedDate),
        'วันที่สมัคร': this.localDate(col.data.createdAt),
        'วันที่ Update ล่าสุด': this.localDate(col.data.updatedAt),
        'สำเนาบัตรประชาชน': col.data.nationalCardImageUrl,
        'รูปถ่ายสำหรับทำบัตรตัวแทน': col.data.sellerCardImageUrl
      }))
      csvExporter.generateCsv(payload)
    },
    localDate (date) {
      if (date === null || date === '' || date === undefined) {
        return '-'
      }
      return dayjs(date).format('DD-MM-YYYY HH:mm')
    },
    displayAge (date) {
      if (date === null || date === '' || date === undefined) {
        return '-'
      }
      const birthday = new Date(date)
      const ageDifMs = Date.now() - birthday.getTime();
      const ageDate = new Date(ageDifMs);
      return Math.abs(ageDate.getUTCFullYear() - 1970)
    },
    print (id) {
      const routeData = this.$router.resolve({name: 'PrintDealer', params: { id }})
      window.open(routeData.href, '_blank')
    },
    async printForm (id) {
      await alert('Print Setting\nMargin: None\nOptions: Background graphics')
      const routeData = this.$router.resolve({name: 'PrintFormDealer', params: { id }})
      window.open(routeData.href, '_blank')
    },
    changePage (page) {
      this.page = page
      this.$router.push({
        name: 'DealerList',
        query: {
          page,
          search: this.$route.query.search ? this.$route.query.search : '',
          sort_by: this.$route.query.sort_by ? this.$route.query.sort_by : 'createdAt',
          sort_order: this.$route.query.sort_order ? this.$route.query.sort_order : 'desc'
        }
      }, () => {})
      this.getData()
    },
    searchItem () {
      this.page = 1
      this.$router.push({
        name: 'DealerList',
        query: {
          page: '1',
          search: this.searchText,
          sort_by: this.$route.query.sort_by ? this.$route.query.sort_by : 'createdAt',
          sort_order: this.$route.query.sort_order ? this.$route.query.sort_order : 'desc'
        }
      }, () => {})
      this.getData()
    },
    async getData () {
      this.loading = true
      try {
        const query = `page=${this.queryPage}&limit=${this.perPage}&search=${this.querySearch}&sortBy=${this.querySortBy}&sortOrder=${this.querySortOrder}`
        const { data } = await dealerService.getDealer(query)
        this.total = data.total
        this.data = data.results
      } catch (err) {
        this.setSnackbar({
          message: err.message,
          type: 'pink',
          active: true
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
